import { Component } from '@angular/core';

@Component({
  selector: 'app-downtime-reason',
  templateUrl: './downtime-reason.component.html',
  styleUrls: ['./downtime-reason.component.scss']
})
export class DowntimeReasonComponent {}
